import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class AdvanceValueGreaterThanRemainingAmount extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.advance-value.greater-than-remaining');
    }
}
